import { CheckoutResponse } from "@/networking/checkout.api";

export function checkoutRedirect(
  result: CheckoutResponse,
  cartToken: string,
): void {
  let url: string;

  if (result.redirect_url && process.env.NODE_ENV !== "development") {
    url = result.redirect_url;
  } else if (result.enrollment?.token) {
    url = `/enrollments/${result.enrollment.token}?cartToken=${cartToken}`;
  } else if (result.order?.order_confirmation_url || result.order?.token) {
    url =
      result.order.order_confirmation_url ?? `/orders/${result.order.token}`;
  } else {
    url = `/checkouts/${cartToken}`;
  }

  window.location.href = url;
}
